import { __decorate, __param } from 'tslib';
import { DOCUMENT, CommonModule } from '@angular/common';
import { InjectionToken, Inject, ElementRef, Input, HostBinding, Component, ChangeDetectionStrategy, NgZone, Directive, NgModule } from '@angular/core';
import { USER_AGENT, ANIMATION_FRAME } from '@ng-web-apis/common';
import { isEdgeOlderThan, isIE, isSafari, blurNativeFocused, isNativeFocusedIn, TUI_IS_IOS, tuiDefaultProp, tuiRequiredSetter, tuiZonefree, TuiDestroyService } from '@taiga-ui/cdk';
import { sizeBigger } from '@taiga-ui/core/utils/miscellaneous';
import { Observable } from 'rxjs';
import { pairwise, takeUntil } from 'rxjs/operators';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';

/** Default values for the loader options. */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@tinkoff/ng-polymorpheus';
import * as ɵngcc3 from 'rxjs';

function TuiLoaderComponent_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("t-text_horizontal", ctx_r1.isHorizontal);
    ɵngcc0.ɵɵproperty("content", ctx_r1.textContent);
} }
function TuiLoaderComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 3);
    ɵngcc0.ɵɵelement(2, "circle", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, TuiLoaderComponent_div_2_div_3_Template, 1, 3, "div", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("t-loader_horizontal", ctx_r0.isHorizontal)("t-loader_inherit-color", ctx_r0.inheritColor);
    ɵngcc0.ɵɵattribute("data-tui-element-size", ctx_r0.size);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasText);
} }
const _c0 = ["*"];
const TUI_LOADER_DEFAULT_OPTIONS = {
    size: 'm',
    inheritColor: false,
    overlay: false,
};
const TUI_LOADER_OPTIONS = new InjectionToken('Default parameters for loader component', {
    factory: () => TUI_LOADER_DEFAULT_OPTIONS,
});
const tuiLoaderOptionsProvider = (options) => ({
    provide: TUI_LOADER_OPTIONS,
    useValue: Object.assign(Object.assign({}, TUI_LOADER_DEFAULT_OPTIONS), options),
});

// @dynamic
let TuiLoaderComponent = class TuiLoaderComponent {
    constructor(documentRef, elementRef, userAgent, isIos, options) {
        this.documentRef = documentRef;
        this.elementRef = elementRef;
        this.userAgent = userAgent;
        this.isIos = isIos;
        this.options = options;
        this.size = this.options.size;
        this.inheritColor = this.options.inheritColor;
        this.overlay = this.options.overlay;
        // TODO: Remove null in 3.0
        this.textContent = null;
        this.loading = true;
        this.animatedWithJs = isEdgeOlderThan(17, this.userAgent) || isIE(this.userAgent);
        this.isApple = isSafari(this.elementRef.nativeElement) || this.isIos;
    }
    set showLoader(value) {
        // @bad TODO: https://github.com/angular/angular/issues/32083 think of a better way
        if (value && this.focused) {
            blurNativeFocused(this.documentRef);
        }
        this.loading = value;
    }
    get hasOverlay() {
        return this.overlay && this.loading;
    }
    get hasText() {
        return !!this.textContent;
    }
    get isHorizontal() {
        return !sizeBigger(this.size);
    }
    get focused() {
        return isNativeFocusedIn(this.elementRef.nativeElement);
    }
};
TuiLoaderComponent.ɵfac = function TuiLoaderComponent_Factory(t) { return new (t || TuiLoaderComponent)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(USER_AGENT), ɵngcc0.ɵɵdirectiveInject(TUI_IS_IOS), ɵngcc0.ɵɵdirectiveInject(TUI_LOADER_OPTIONS)); };
TuiLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiLoaderComponent, selectors: [["tui-loader"]], hostVars: 4, hostBindings: function TuiLoaderComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("_loading", ctx.loading)("_animated-with-js", ctx.animatedWithJs);
    } }, inputs: { size: "size", inheritColor: "inheritColor", overlay: "overlay", textContent: "textContent", showLoader: "showLoader" }, ngContentSelectors: _c0, decls: 3, vars: 6, consts: [[1, "t-content", 3, "disabled"], ["class", "t-loader", 3, "t-loader_horizontal", "t-loader_inherit-color", 4, "ngIf"], [1, "t-loader"], ["automation-id", "tui-loader__loader", "focusable", "false", "viewBox", "0 0 100 100", "xmlns", "http://www.w3.org/2000/svg", 1, "t-icon"], ["cx", "50", "cy", "50", "r", "50", "stroke-dasharray", "314", 1, "t-circle"], ["polymorpheus-outlet", "", "automation-id", "tui-loader__text", "class", "t-text", 3, "t-text_horizontal", "content", 4, "ngIf"], ["polymorpheus-outlet", "", "automation-id", "tui-loader__text", 1, "t-text", 3, "content"]], template: function TuiLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "fieldset", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, TuiLoaderComponent_div_2_Template, 4, 6, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("t-content_has-overlay", ctx.hasOverlay)("t-content_loading", ctx.loading);
        ɵngcc0.ɵɵproperty("disabled", ctx.loading && !ctx.isApple);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
    } }, directives: function () { return [ɵngcc1.NgIf, TuiLoaderDirective, ɵngcc2.PolymorpheusOutletComponent]; }, styles: ["@-webkit-keyframes tuiLoaderDashOffset{0%,100%{stroke-dashoffset:-66}50%{stroke-dashoffset:-314}}@keyframes tuiLoaderDashOffset{0%,100%{stroke-dashoffset:-66}50%{stroke-dashoffset:-314}}@-webkit-keyframes tuiLoaderRotate{0%{transform:rotate(0)}50%{transform:rotate(1turn)}100%{transform:rotate(3turn)}}@keyframes tuiLoaderRotate{0%{transform:rotate(0)}50%{transform:rotate(1turn)}100%{transform:rotate(3turn)}}[_nghost-%COMP%]{position:relative;display:flex}._loading[_nghost-%COMP%]{overflow:hidden}.t-content[_ngcontent-%COMP%]{z-index:0;min-width:100%;height:100%;padding:0;margin:0;border:none}.t-content_has-overlay[_ngcontent-%COMP%]{opacity:.3}.t-content_loading[_ngcontent-%COMP%]{pointer-events:none}.t-loader[_ngcontent-%COMP%]{position:relative;left:-100%;display:flex;flex-direction:column;align-items:center;justify-content:center;min-width:100%;flex-shrink:0;align-self:center;color:var(--tui-text-01);stroke:var(--tui-primary);-webkit-animation:tuiFadeIn var(--tui-duration);animation:tuiFadeIn var(--tui-duration)}.t-loader.t-loader_horizontal[_ngcontent-%COMP%]{flex-direction:row}.t-loader.t-loader_inherit-color[_ngcontent-%COMP%]{color:inherit;stroke:currentColor}.t-loader[data-tui-element-size=xs][_ngcontent-%COMP%]{font-size:.75rem;stroke-width:38}.t-loader[data-tui-element-size='s'][_ngcontent-%COMP%]{font-size:1rem;stroke-width:25}.t-loader[data-tui-element-size='m'][_ngcontent-%COMP%]{font-size:1.5rem;stroke-width:17}.t-loader[data-tui-element-size='l'][_ngcontent-%COMP%]{font-size:2.5rem;stroke-width:15}.t-loader[data-tui-element-size=xl][_ngcontent-%COMP%]{font-size:3.5rem;stroke-width:14}.t-loader[data-tui-element-size=xxl][_ngcontent-%COMP%]{font-size:5rem;stroke-width:10}.t-text[_ngcontent-%COMP%]{font:var(--tui-font-text-s);color:var(--tui-text-01);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:1rem;color:inherit;max-width:100%;text-align:center;stroke-width:0}.t-text_horizontal[_ngcontent-%COMP%]{margin:0 0 0 1rem}.t-icon[_ngcontent-%COMP%]{display:block;min-width:1em;max-width:1em;min-height:1em;max-height:1em;margin:.25rem -.5em;border-radius:100%;overflow:hidden;transform:scale(1,-1)}[_nghost-%COMP%]:not(._animated-with-js)   .t-icon[_ngcontent-%COMP%]{-webkit-animation:3s linear infinite tuiLoaderRotate;animation:3s linear infinite tuiLoaderRotate}.t-circle[_ngcontent-%COMP%]{fill:none;stroke:inherit;stroke-width:inherit;-webkit-animation:3s linear infinite tuiLoaderDashOffset;animation:3s linear infinite tuiLoaderDashOffset}"], changeDetection: 0 });
TuiLoaderComponent.ctorParameters = () => [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: String, decorators: [{ type: Inject, args: [USER_AGENT,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_IOS,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_LOADER_OPTIONS,] }] }
];
__decorate([
    Input(),
    tuiDefaultProp()
], TuiLoaderComponent.prototype, "size", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiLoaderComponent.prototype, "inheritColor", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiLoaderComponent.prototype, "overlay", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiLoaderComponent.prototype, "textContent", void 0);
__decorate([
    Input(),
    tuiRequiredSetter()
], TuiLoaderComponent.prototype, "showLoader", null);
__decorate([
    HostBinding('class._loading')
], TuiLoaderComponent.prototype, "loading", void 0);
__decorate([
    HostBinding('class._animated-with-js')
], TuiLoaderComponent.prototype, "animatedWithJs", void 0);
TuiLoaderComponent = __decorate([ __param(0, Inject(DOCUMENT)),
    __param(1, Inject(ElementRef)),
    __param(2, Inject(USER_AGENT)),
    __param(3, Inject(TUI_IS_IOS)),
    __param(4, Inject(TUI_LOADER_OPTIONS))
], TuiLoaderComponent);

const PERIMETER = 314;
const COEFFICIENT = 1.5;
/**
 * @deprecated
 */
let TuiLoaderDirective = class TuiLoaderDirective {
    constructor(animationFrame$, ngZone, destroy$, elementRef, userAgent) {
        this.elementRef = elementRef;
        this.strokeDasharray = PERIMETER;
        this.strokeDashoffset = 0;
        if (!isEdgeOlderThan(17, userAgent) && !isIE(userAgent)) {
            return;
        }
        animationFrame$
            .pipe(tuiZonefree(ngZone), pairwise(), takeUntil(destroy$))
            .subscribe(([cur, prev]) => {
            this.animate(prev - cur);
        });
    }
    animate(delta) {
        if (this.strokeDasharray < 0) {
            this.strokeDasharray = PERIMETER * 2;
            this.strokeDashoffset = 0;
        }
        const strokeDasharray = Math.abs(this.strokeDasharray - PERIMETER);
        const fps = 1000 / delta;
        const offsetStep = 1 + Math.floor(this.strokeDasharray / PERIMETER);
        const { style } = this.elementRef.nativeElement;
        style.strokeDashoffset = String(this.strokeDashoffset);
        style.strokeDasharray = `${PERIMETER - strokeDasharray} ${strokeDasharray}`;
        this.strokeDasharray -= PERIMETER / COEFFICIENT / fps;
        this.strokeDashoffset += (offsetStep * PERIMETER) / COEFFICIENT / fps;
        // this.elementRef.nativeElement.parentElement!.style.animation = 'none';
    }
};
TuiLoaderDirective.ɵfac = function TuiLoaderDirective_Factory(t) { return new (t || TuiLoaderDirective)(ɵngcc0.ɵɵdirectiveInject(ANIMATION_FRAME), ɵngcc0.ɵɵdirectiveInject(NgZone), ɵngcc0.ɵɵdirectiveInject(TuiDestroyService), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(USER_AGENT)); };
TuiLoaderDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiLoaderDirective, selectors: [["circle"]], features: [ɵngcc0.ɵɵProvidersFeature([TuiDestroyService])] });
TuiLoaderDirective.ctorParameters = () => [
    { type: Observable, decorators: [{ type: Inject, args: [ANIMATION_FRAME,] }] },
    { type: NgZone, decorators: [{ type: Inject, args: [NgZone,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TuiDestroyService,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: String, decorators: [{ type: Inject, args: [USER_AGENT,] }] }
];
TuiLoaderDirective = __decorate([ __param(0, Inject(ANIMATION_FRAME)),
    __param(1, Inject(NgZone)),
    __param(2, Inject(TuiDestroyService)),
    __param(3, Inject(ElementRef)),
    __param(4, Inject(USER_AGENT))
], TuiLoaderDirective);

let TuiLoaderModule = class TuiLoaderModule {
};
TuiLoaderModule.ɵfac = function TuiLoaderModule_Factory(t) { return new (t || TuiLoaderModule)(); };
TuiLoaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiLoaderModule });
TuiLoaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, PolymorpheusModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'tui-loader',
                template: "<fieldset\n    class=\"t-content\"\n    [class.t-content_has-overlay]=\"hasOverlay\"\n    [class.t-content_loading]=\"loading\"\n    [disabled]=\"loading && !isApple\"\n>\n    <ng-content></ng-content>\n</fieldset>\n\n<div\n    *ngIf=\"loading\"\n    class=\"t-loader\"\n    [class.t-loader_horizontal]=\"isHorizontal\"\n    [class.t-loader_inherit-color]=\"inheritColor\"\n    [attr.data-tui-element-size]=\"size\"\n>\n    <svg\n        automation-id=\"tui-loader__loader\"\n        focusable=\"false\"\n        viewBox=\"0 0 100 100\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        class=\"t-icon\"\n    >\n        <circle\n            cx=\"50\"\n            cy=\"50\"\n            r=\"50\"\n            stroke-dasharray=\"314\"\n            class=\"t-circle\"\n        ></circle>\n    </svg>\n\n    <div\n        *ngIf=\"hasText\"\n        polymorpheus-outlet\n        automation-id=\"tui-loader__text\"\n        class=\"t-text\"\n        [class.t-text_horizontal]=\"isHorizontal\"\n        [content]=\"textContent\"\n    ></div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["@-webkit-keyframes tuiLoaderDashOffset{0%,100%{stroke-dashoffset:-66}50%{stroke-dashoffset:-314}}@keyframes tuiLoaderDashOffset{0%,100%{stroke-dashoffset:-66}50%{stroke-dashoffset:-314}}@-webkit-keyframes tuiLoaderRotate{0%{transform:rotate(0)}50%{transform:rotate(1turn)}100%{transform:rotate(3turn)}}@keyframes tuiLoaderRotate{0%{transform:rotate(0)}50%{transform:rotate(1turn)}100%{transform:rotate(3turn)}}:host{position:relative;display:flex}:host._loading{overflow:hidden}.t-content{z-index:0;min-width:100%;height:100%;padding:0;margin:0;border:none}.t-content_has-overlay{opacity:.3}.t-content_loading{pointer-events:none}.t-loader{position:relative;left:-100%;display:flex;flex-direction:column;align-items:center;justify-content:center;min-width:100%;flex-shrink:0;align-self:center;color:var(--tui-text-01);stroke:var(--tui-primary);-webkit-animation:tuiFadeIn var(--tui-duration);animation:tuiFadeIn var(--tui-duration)}.t-loader.t-loader_horizontal{flex-direction:row}.t-loader.t-loader_inherit-color{color:inherit;stroke:currentColor}.t-loader[data-tui-element-size=xs]{font-size:.75rem;stroke-width:38}.t-loader[data-tui-element-size='s']{font-size:1rem;stroke-width:25}.t-loader[data-tui-element-size='m']{font-size:1.5rem;stroke-width:17}.t-loader[data-tui-element-size='l']{font-size:2.5rem;stroke-width:15}.t-loader[data-tui-element-size=xl]{font-size:3.5rem;stroke-width:14}.t-loader[data-tui-element-size=xxl]{font-size:5rem;stroke-width:10}.t-text{font:var(--tui-font-text-s);color:var(--tui-text-01);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:1rem;color:inherit;max-width:100%;text-align:center;stroke-width:0}.t-text_horizontal{margin:0 0 0 1rem}.t-icon{display:block;min-width:1em;max-width:1em;min-height:1em;max-height:1em;margin:.25rem -.5em;border-radius:100%;overflow:hidden;transform:scale(1,-1)}:host:not(._animated-with-js) .t-icon{-webkit-animation:3s linear infinite tuiLoaderRotate;animation:3s linear infinite tuiLoaderRotate}.t-circle{fill:none;stroke:inherit;stroke-width:inherit;-webkit-animation:3s linear infinite tuiLoaderDashOffset;animation:3s linear infinite tuiLoaderDashOffset}"]
            }]
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [USER_AGENT]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_IOS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_LOADER_OPTIONS]
            }] }]; }, { size: [{
            type: Input
        }], inheritColor: [{
            type: Input
        }], overlay: [{
            type: Input
        }], textContent: [{
            type: Input
        }], loading: [{
            type: HostBinding,
            args: ['class._loading']
        }], animatedWithJs: [{
            type: HostBinding,
            args: ['class._animated-with-js']
        }], showLoader: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiLoaderDirective, [{
        type: Directive,
        args: [{
                selector: 'circle',
                providers: [TuiDestroyService]
            }]
    }], function () { return [{ type: ɵngcc3.Observable, decorators: [{
                type: Inject,
                args: [ANIMATION_FRAME]
            }] }, { type: ɵngcc0.NgZone, decorators: [{
                type: Inject,
                args: [NgZone]
            }] }, { type: ɵngcc3.Observable, decorators: [{
                type: Inject,
                args: [TuiDestroyService]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [USER_AGENT]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiLoaderModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, PolymorpheusModule],
                declarations: [TuiLoaderComponent, TuiLoaderDirective],
                exports: [TuiLoaderComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiLoaderModule, { declarations: function () { return [TuiLoaderComponent, TuiLoaderDirective]; }, imports: function () { return [CommonModule, PolymorpheusModule]; }, exports: function () { return [TuiLoaderComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_LOADER_DEFAULT_OPTIONS, TUI_LOADER_OPTIONS, TuiLoaderComponent, TuiLoaderDirective, TuiLoaderModule, tuiLoaderOptionsProvider };

